/**
 * 查询单应用菜单路由
 */
import {
  baseAuthorityApi,
  baseTenantApi
} from '@klinx/base/src/api/index.js';
import {
  COMMON_ROUTES
} from '@/views/home/config';
import db from '@klinx/utils/localstorage';
import { mapGetters } from 'vuex';
import i18n from '@/lang';
const $t = (args) => i18n.t(args);

export default {
  computed: {
    ...mapGetters([
      'envConfig'
    ])
  },
  methods: {
    async getVersion() {
      const res = await baseTenantApi.getVersion();
      if (res.data.isSuccess) {
        return res.data.data || '';
      }
      return '';
    },
    async onAppClick(item, jump = true) {
      const {
        isOpen
      } = item;
      if (!isOpen) {
        this.$message($t('应用未开通'));
        return false;
      }
      try {
        let hasBase = false;
        const routerList = [];
        const res = await baseAuthorityApi.getRouter({
          appCode: item.code
        });
        if (!(res.data.isSuccess && res.data.data?.length)) {
          this.$message.error($t('获取应用内菜单为空，请联系管理员'));
          return false;
        }
        res.data.data.forEach(app => {
          if ([item.code, 'base'].includes(app.appCode)) {
            app.appCode !== 'base' && app.children ? routerList.push(...app.children) : routerList.push(app);
          }
          if (app.appCode === 'base') {
            hasBase = true;
          }
        });
        // 如果没有默认返回base菜单，则单独查
        if (!hasBase) {
          const baseRes = await baseAuthorityApi.getRouter({
            appCode: 'base'
          });
          baseRes.data.isSuccess && baseRes.data.data?.length && routerList.push(...baseRes.data.data);
        }
        if (this.setRouter(routerList)) {
          const homeUrl = routerList.filter(item => item.name === this.$t('首页'))[0]; // 菜单里有首页则跳首页
          const redirectPath = this.envConfig[`VUE_APP_${item.code}_REDIRECT_HOME`] || homeUrl?.path || '/dashboard';
          this.$store.commit('account/SET_CURRENT_APP', item);
          document.title = item.appName;
          jump && this.$router.push({
            path: redirectPath
          });
          return true;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    setRouter(routerList) {
      const commonRouter = [];
      const appRouter = [];
      let asyncRouter = [];
      routerList.forEach(item => {
        // 过滤非pc端的菜单
        if (item.group !== 'pc') {
          return;
        }
        if (COMMON_ROUTES.includes(item.path)) {
          commonRouter.push({
            ...item,
            isCommon: true
          });
        } else {
          appRouter.push(item);
        }
      });
      asyncRouter = [...appRouter, ...commonRouter];
      asyncRouter.forEach(v => {
      // 处理报告设计器跳转参数拼接
        if (v.appCode === 'iMES' && v.path === '/mes/setting') {
          v.children.map(vItem => {
            if (vItem.component === 'http://hostip:port/?response_type=out_code') {
              vItem.path = JSON.parse(JSON.stringify(vItem.path + '&tenant_code=' + db.get('TENANT') +
                '&tenant_name=' + db.get('TENANT_NAME') + '&account=' + db.get('USER').account + '&aid=' +
                db.get('USER').account));
            }
            return vItem;
          });
        }

        // 需要拼接参数的菜单
        (v.children || []).forEach(vItem => {
          if (vItem.component && vItem.component.includes('concatSearch')) {
            const [path, search] = vItem.path.split('?');
            vItem.path = search.split('&').reduce((acc, cur) => {
              const [key, value] = cur.split('=');
              if (/\[.*?\]/.test(value)) {
                const userKey = value.replace(/\[|\]/g, '');
                acc = `${acc}${acc.includes('?') ? '&' : '?'}${key}=${db.get('USER')[userKey]}`;
              } else {
                acc = `${acc}${acc.includes('?') ? '&' : '?'}${key}=${value}`;
              }
              return acc;
            }, path);
          }
        });
      });
      console.log($t('查询用户可用的所有菜单路由树'), asyncRouter);
      // 暂未配置菜单权限
      if (!asyncRouter.length) {
        // 其他没有访问权限的页面被重定向到登录页面。
        this.$message.error($t('当前租户暂未配置菜单权限，请联系管理员'));
        console.log($t('当前租户暂未配置菜单权限，请联系管理员'));
        return false;
      } else {
        asyncRouter.push({
          alwaysShow: false,
          component: 'error-page/404',
          hidden: false,
          name: '404',
          path: '*'
        });
        // 缓存
        this.$store.commit('account/setRoutes', asyncRouter);
      }
      return true;
    }
  }
};
